<template>
    <form @submit.prevent="onSubmit" class="z2">
        <div class="form__row">
            <div class="form__item" v-if="create">
                <accessory-autocomplete v-if="create" :v="$v" v-model="$v.accessoryTypeId.$model" name="accessoryTypeId" length-type="w--l"/>
            </div>

            <div class="form__item">
                <form-input label="Plocha" :v="$v" name="area" v-model="$v.area.$model" length-type="w--xxs" suffix="㎡" />
            </div>
        </div>
        <div class="form__row">

        </div>
        <div class="form__row">
            <div class="form__item">
                <form-checkbox label="Možnost přikoupit" :v="$v" name="possibleToBuy" v-model="$v.possibleToBuy.$model"/>
            </div>
        </div>
        <div class="form__row" v-if="possibleToBuy">
            <div class="form__item">
                <form-input label="Cena s DPH" :v="$v" name="priceVat" v-model="$v.priceVat.$model"/>
            </div>
        </div>
        <div class="form__row">
            <custom-button type="submit" outline>
                {{submitButtonValue}}
            </custom-button>
        </div>
    </form>
</template>

<script>
import {required, decimal, requiredIf} from 'vuelidate/lib/validators';
import FormInput from 'domovio-core/src/components/Form/Input/FormInput';
import FormCheckbox from 'domovio-core/src/components/Form/Input/FormCheckbox';
import AccessoryAutocomplete from '@/components/Autocomplete/AccessoryAutocomplete';
import CustomButton from 'domovio-core/src/components/Button/CustomButton';

export default {
    name:       'AccessoryOptionForm',
    components: {
        CustomButton,
        AccessoryAutocomplete,
        FormCheckbox,
        FormInput

    },
    props:      {
        create:            {
            type:     Boolean,
            required: false,
            default:  true,
        },
        submitButtonValue: {
            type:     String,
            required: false,
            default:  () => 'Uložit',
        }
    },
    data() {
        return {
            accessoryTypeId: null,
            area:            null,
            possibleToBuy:   false,
            priceVat:        null,
        }
    },
    validations() {
        return {
            accessoryTypeId: { required: requiredIf('create') },
            area:            { required, decimal, },
            possibleToBuy:   {},
            priceVat:        { required: requiredIf('possibleToBuy'), decimal },
        }
    },
    methods:    {
        onSubmit() {
            this.$v.$touch();
            if (false === this.$v.$invalid) {
                const { area, possibleToBuy, priceVat, accessoryTypeId } = this;
                let parameters = {
                    area:     parseFloat(area),
                    priceVat: parseFloat(priceVat),
                    possibleToBuy
                };
                if (this.create) parameters['accessoryTypeId'] = accessoryTypeId;
                this.$emit('o3-submit', parameters);
            }
        },
        reset() {
            this.area = null;
            this.numberOfFloors = null;
            this.numberOfFloorsAboveGround = null;
            this.phaseId = null;
            this.$v.$reset();
        },
        setValues(data) {
            const { area, possibleToBuy, price } = data;
            this.area = area;
            this.possibleToBuy = possibleToBuy;
            this.priceVat = null !== price ? price.withVat : null;
        }
    }
}
</script>
